export const modal = () => {
  return {
    namespaced: true,
    state: {
      open: false,
      data: {},
    },
    mutations: {
      SET_DATA (state, data) {
        state.data = data
      },
      SET_OPEN (state, bool) {
        state.open = bool
      }
    },
    actions: {
      setData ({ commit }, data) {
        commit('SET_DATA', data)
      },
      setOpen ({ commit }, bool) {
        commit('SET_OPEN', bool)
      }
    }
  }
}
